import { lookbookImageLoader } from "./lookbook-image-loader";

const CONTENTFUL_HOSTNAME = "images.ctfassets.net";

type ImageLoaderParams = {
  src: string;
  width?: number;
  height?: number;
  quality?: number;
};

export function cmsImageLoader({
  src,
  width,
  height,
  quality,
}: ImageLoaderParams): string {
  try {
    const url = new URL(src);
    if (url.hostname === CONTENTFUL_HOSTNAME) {
      if (width) {
        url.searchParams.set("w", String(width));
      }
      if (height) {
        url.searchParams.set("h", String(height));
      }
      url.searchParams.set("q", String(quality || 75));
      url.searchParams.set("fm", "webp");
      url.searchParams.set("fit", "fill");
      return url.toString();
    }
  } catch {
    // TODO: Add logging
  }

  return lookbookImageLoader({ src, width, height, quality });
}
